import React from 'react';

function AskQuestionIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 56 47"
            {...props}
        >
            <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
                <g fill="#707076">
                    <circle cx="28" cy="31" r="1" data-original="#000000" />
                    <path
                        d="M29.08 6.083a6.98 6.98 0 00-7.2 3.525 1 1 0 101.748.971A4.981 4.981 0 0128.006 8c.26 0 .518.02.775.058a5.034 5.034 0 014.183 4.342 4.982 4.982 0 01-4.247 5.555A2.006 2.006 0 0027 19.923V24a1 1 0 002 0v-3.25a1 1 0 01.753-.969 6.936 6.936 0 005.2-7.617 7.063 7.063 0 00-5.873-6.081z"
                        data-original="#000000"
                    />
                    <path
                        fillRule="nonzero"
                        d="M49 0H7a7 7 0 00-7 7v24a7 7 0 007 7h4a2 2 0 012 2v5.689a1 1 0 001.646.763l9.428-7.978A2 2 0 0125.367 38H49a7 7 0 007-7V7a7 7 0 00-7-7zM7 4a3 3 0 00-3 3 1 1 0 11-2 0 5.006 5.006 0 015-5 1 1 0 110 2zm21 30a3 3 0 110-6 3 3 0 010 6zm3-12.506V24a3 3 0 01-6 0v-4.077a4.014 4.014 0 013.434-3.952 3 3 0 10-3.061-4.421 3 3 0 01-5.246-2.912 8.953 8.953 0 019.251-4.533 9.093 9.093 0 017.559 7.827A8.916 8.916 0 0131 21.494zM49 36a1 1 0 010-2 3 3 0 003-3 1 1 0 012 0 5.006 5.006 0 01-5 5z"
                        data-original="#000000"
                    />
                </g>
            </g>
        </svg>
    );
}

export { AskQuestionIcon };
